import type { ImplantSession } from '../../hooks/useImplantSession';
import { LEGACY_CHUTE_IMPLANT_PATH } from '../../inClinicPath';
import type { EmbryoViewMode, FreshEmbryoFilters } from '../../types';

/**
 * Build the URLSearchParams that need to flow with the user back to the
 * In Clinic home screen. Empty / unset session fields are dropped so the
 * URL stays tidy. Used by the auto-return-home flow after a successful
 * Implant or Heat Not Used submit.
 */
export function buildSessionParams(
  session: ImplantSession,
  viewMode?: EmbryoViewMode,
  embryoFilters: FreshEmbryoFilters = [],
  fertSiteId = '',
): URLSearchParams {
  const p = new URLSearchParams();
  if (session.siteId) p.set('siteId', session.siteId);
  if (session.yardId) p.set('yardId', session.yardId);
  if (session.vetId) p.set('vetId', session.vetId);
  if (session.techId) p.set('techId', session.techId);
  if (session.chuteNumber) p.set('chuteNumber', session.chuteNumber.toString());
  if (session.impDate) p.set('impDate', session.impDate);
  if (session.caneSearch) p.set('cane', session.caneSearch);
  if (viewMode) p.set('viewMode', viewMode);
  if (fertSiteId && fertSiteId !== session.siteId)
    p.set('fertSiteId', fertSiteId);
  embryoFilters.forEach((filter) => p.append('embryoType', filter));
  return p;
}

/** Final URL the auto-return navigates to. */
export function buildHomeUrl(
  session: ImplantSession,
  viewMode?: EmbryoViewMode,
  embryoFilters: FreshEmbryoFilters = [],
  fertSiteId = '',
  basePath = LEGACY_CHUTE_IMPLANT_PATH,
): string {
  const qs = buildSessionParams(
    session,
    viewMode,
    embryoFilters,
    fertSiteId,
  ).toString();
  return qs ? `${basePath}?${qs}` : basePath;
}
